import Vue from 'vue';
import './layout.scss';
import layoutBase from '../layout-base';
import '../../applications/ethic/ethic.js';

new Vue({
	extends: layoutBase,
	components: {}
}).$mount('[data-layout-id="ALAN-app"]');
